import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.css', '../../../../../assets/css/new-component-view.css', '../../../../../assets/css/new-buttons-theme.css'],
})
export class DropdownComponent implements OnInit {

  @Input() dropdownIcon: string;
  @Input() dropdownLabel: string;
  @Input() options: Record<string, string>[];

  @Output() optionSelectedValue = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
  }

  optionSelected(option: string) {
    this.optionSelectedValue.emit(option);
  }

}
